import styles from './courses.module.css';
import coursesBackground from '../assets/courseBackground.png';

import crashcourse from '../assets/crashcourse.png';
import instclass from '../assets/instclass.png';
import homeclass from '../assets/homeclass.png';

// WhatsApp number from .env (NO + symbol)
const WHATSAPP_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER;

const Courses = () => {
  const courseTypes = [
    {
      id: 1,
      title: 'CRASH COURSES',
      description: 'Intensive short-term programs',
      image: crashcourse,
      whatsappMessage: `
Hello Vibe Musicals Team 

I’m interested in the *Crash Courses*.

Could you please share:
• Course duration
• Available instruments
• Fees
• Batch start dates

Thank you!
`
    },
    {
      id: 2,
      title: 'INSTITUTE CLASSES',
      description: 'Structured in-person learning',
      image: instclass,
      whatsappMessage: `
Hello Vibe Musicals Team 

I’d like to know more about *Institute Classes*.

Please share details about:
• Timings
• Batch size
• Instruments offered
• Fees structure

Looking forward to your response.
`
    },
    {
      id: 3,
      title: 'HOME CLASSES',
      description: 'Personalized one-on-one sessions',
      image: homeclass,
      whatsappMessage: `
Hello Vibe Musicals Team 

I’m interested in *Home Classes*.

Kindly provide:
• Availability
• Instruments covered
• Pricing
• Trainer experience

Thank you!
`
    }
  ];

 const handleEnrollClick = (message) => {
  const number = WHATSAPP_NUMBER || '919080465878'; 
  
  const encodedMessage = encodeURIComponent(message);
  window.open(
    `https://wa.me/${number}?text=${encodedMessage}`,
    '_blank'
  );
};

console.log('WhatsApp Number:', import.meta.env.VITE_WHATSAPP_NUMBER);

  return (
    <div id="courses" className={styles.coursesPage}>
      <section
        className={styles.coursesHero}
        style={{ backgroundImage: `url(${coursesBackground})` }}
      >
        <div className={styles.coursesOverlay}></div>

        <div className={styles.coursesContent}>
          <h1 className={`${styles.coursesTitle} ${styles['fade-in-up']}`}>
            Courses
          </h1>

          <div className={styles.coursesGrid}>
            {courseTypes.map((course) => (
              <div
                key={course.id}
                className={`${styles.courseCard} ${styles['fade-in-up']}`}
              >
                <div
                  className={styles.courseImage}
                  style={{ backgroundImage: `url(${course.image})` }}
                >
                  <div className={styles.courseImageOverlay}></div>
                </div>

                <div className={styles.courseInfo}>
                  <h2 className={styles.courseCardTitle}>
                    {course.title}
                  </h2>

                  <button
                    className={styles.enrollBtn}
                    onClick={() => handleEnrollClick(course.whatsappMessage)}
                  >
                    ENROLL
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Courses;
